import React, { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import { isEmpty as _isEmpty } from 'lodash-es';
import { Form } from 'antd';
import { CountryCodeContext } from '../FormSettings/helpers';

const PhoneInputFormItem = forwardRef(({ onChange, value, error }, ref) => {
  const countryCode = useContext(CountryCodeContext);


  const inputRef = useRef();
  useImperativeHandle(
    ref,
    () => {
      return {
        focus() {
          if (inputRef.current && inputRef.current.numberInputRef)
            inputRef.current.numberInputRef?.focus();
        },
      };
    },
    [],
  );

  return (
    <Form.Item
      validateStatus={_isEmpty(error) ? 'success' : 'error'}
      help={!_isEmpty(error) ? error?.message : null}
    >
      <PhoneInput
        autoFormat="false"
        country={value === null || value === undefined ? countryCode : ''}
        enableSearch="true"
        enableLongNumbers="true"
        placeholder=""
        value={value}
        disableSearchIcon="false"
        preferredCountries={['us', 'in', 'br', 'gb']}
        onChange={onChange}
        ref={inputRef}
      />
    </Form.Item>
  );
});
// ESLint says this is required 🤷🏼‍♂️
PhoneInputFormItem.displayName = 'PhoneInputFormItem';

export default PhoneInputFormItem;
